"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Instagram;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Instagram(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Instagram"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "instagram",
    d: "M50.009,29.494A20.507,20.507,0,1,0,70.515,50,20.474,20.474,0,0,0,50.009,29.494Zm0,33.838A13.332,13.332,0,1,1,63.341,50,13.356,13.356,0,0,1,50.009,63.332ZM76.137,28.655a4.783,4.783,0,1,1-4.783-4.783A4.772,4.772,0,0,1,76.137,28.655Zm13.582,4.854c-.3-6.407-1.767-12.082-6.461-16.758-4.676-4.676-10.351-6.14-16.758-6.461-6.6-.375-26.4-.375-33,0-6.389.3-12.064,1.767-16.758,6.443S10.6,27.084,10.281,33.492c-.375,6.6-.375,26.4,0,33,.3,6.407,1.767,12.082,6.461,16.758S27.093,89.389,33.5,89.71c6.6.375,26.4.375,33,0,6.407-.3,12.082-1.767,16.758-6.461,4.676-4.676,6.14-10.351,6.461-16.758.375-6.6.375-26.378,0-32.982ZM81.188,73.576a13.5,13.5,0,0,1-7.6,7.6c-5.265,2.088-17.758,1.606-23.576,1.606s-18.329.464-23.576-1.606a13.5,13.5,0,0,1-7.6-7.6C16.742,68.311,17.224,55.818,17.224,50S16.76,31.671,18.83,26.424a13.5,13.5,0,0,1,7.6-7.6c5.265-2.088,17.758-1.606,23.576-1.606s18.329-.464,23.576,1.606a13.5,13.5,0,0,1,7.6,7.6C83.276,31.689,82.794,44.182,82.794,50S83.276,68.329,81.188,73.576Z"
  })));
}